import * as Yup from 'yup';

// Schema factory function to create billing order first step schema with translation function
export const createBillingOrderFirstStepSchema = (t: (key: string) => string) => {
  return Yup.object().shape({
    onlySave: Yup.boolean().default(false),
    organization: Yup.object().required(t('Which organization is this billing order for?')),
    milestones: Yup.array()
      .min(1, t('Please pick at least one milestone to continue'))
      .required(t('We need to select some milestones for this billing order')),
  });
};
